import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

// Components
import ThemeMenuOne from '../../../components/header/ThemeMenuOne'
import PageTitle from '../../../components/page-title/PageTitle'
import NewsletterOne from '../../../components/call-to-action/NewsletterOne'
import FooterOne from '../../../components/footer/FooterOne'

const BlogGrid = () => {
  return (
    <Fragment>
      <div className="main-page-wrapper">
        {/* Helmet start */}
        <Helmet>
          <title>Blog Grid || Techy – IT Solution & Web Security React Template</title>
        </Helmet>
        {/* Helmet end */}

        {/* ThemeMenuOne */}
        <ThemeMenuOne />
        {/* ThemeMenuOne */}

        {/* PageTitle */}
        <PageTitle title="Blog Grid" />
        {/* PageTitle */}

        {/* blog-grid-area start */}
        <section className="blog-grid-area pt-150 pb-105 pt-lg-60 pb-lg-15">
          <div className="container">
            <div className="row">
              {/* Aquí puedes añadir tus tarjetas de blog si las tienes */}
              <div className="col-lg-12 d-flex align-items-center justify-content-center mb-45">
                <button className="theme_btn" onClick={() => alert("No hay más entradas disponibles")}>
                  Load More
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* blog-grid-area end */}

        {/* techy-newsletter start */}
        <NewsletterOne />
        {/* techy-newsletter end */}

        {/* Footer start */}
        <FooterOne />
        {/* Footer end */}
      </div>
    </Fragment>
  )
}

export default BlogGrid
